module.exports = __webpack_public_path__ + "assets/img/spinner.86572306.svg";